import React from 'react'
import UserAvatar from '../../user/user-avatar/UserAvatar'
import { ButtonPrimary } from 'front-end/src/components'
import { Trans } from '@lingui/macro'
import { IMembersSelectorUser } from '../MembersSelectors.types'

type UserRowProps = {
  user: IMembersSelectorUser
  action: 'add' | 'remove'
}

export const UserRow: React.FC<UserRowProps> = React.memo<UserRowProps>(
  ({ user, action }) => {
    return (
      <>
        <UserAvatar user={user} size="small" />
        <span className="MembersSelector__user">
          {user.display_name}
          <span className="identity">{user.userIdentity}</span>
        </span>
        {user.cantBeSelectedReason && (
          <ButtonPrimary size="xs" className="CantBeAddedLabel">
            {user.cantBeSelectedReason}
          </ButtonPrimary>
        )}
        {!user.cantBeSelectedReason && action === 'add' && (
          <ButtonPrimary size="xs" className="Action">
            <Trans>Add</Trans>
          </ButtonPrimary>
        )}
        {action === 'remove' && (
          <ButtonPrimary size="xs" className="Action">
            <Trans>Remove</Trans>
          </ButtonPrimary>
        )}
      </>
    )
  }
)
